import { PayloadEpic } from '@/store/epics/epic-types';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { actions, asyncActions } from '@/store/slices';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { apiEndpoints } from '@/store/constants';
import { EntityId } from '@reduxjs/toolkit';
import { AssetModel } from '@/models';

export const unarchiveInventoryAssetEpic: PayloadEpic<EntityId, unknown> = (action$) => {
    return action$.pipe(
        filter(asyncActions.assets.unarchiveAsset.match),
        switchMap(({ payload }) => concat(
            of(actions.assets.setIsUnarchivingAsset(true)),
            unarchiveAsset(payload).pipe(
                map(({ data }) => actions.assets.upsertOne(data)),
                catchError((error) => {
                    console.error('unarchiveInventoryAssetEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.assets.setIsUnarchivingAsset(false)),
        )),
    );
};

const unarchiveAsset = (assetId: EntityId) => {
    return axios.post<AssetModel>(apiEndpoints.inventoryAssetUnarchive(assetId));
};
